import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import {
  useRecoilValue
} from 'recoil';
import {
  businessAtom,
} from '../../../atoms/Atoms';
import ItemPrices from './ItemPrices';

function StoreItemPrices() {
  const business = useRecoilValue(businessAtom);
  const history = useHistory();
  useEffect(() => {
    if (!business) {
      history.push('/');
    }
  }, [business]);

  return (
    <ItemPrices hideStorePicker />
  );
}
export default StoreItemPrices;
